import React from "react";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import { Confirm, useDeleteWithConfirmController, useTranslate } from "react-admin";

type Props = {
  record: any;
  resource: string;
  label?: string;
  icon?: React.ReactElement;
  confirmTitle: React.ReactNode;
  confirmContent: React.ReactNode;
  mutationMode: "pessimistic";
  mutationOptions: any;
};

export const MobileDeleteWithConfirmButton = ({
  record,
  resource,
  label = "ra.action.delete",
  icon = <DeleteIcon />,
  confirmTitle,
  confirmContent,
  mutationMode,
  mutationOptions,
}: Props) => {
  const translate = useTranslate();
  const { open, isLoading, handleDialogOpen, handleDialogClose, handleDelete } = useDeleteWithConfirmController({
    record,
    resource,
    redirect: false,
    mutationMode,
    mutationOptions,
  });

  return (
    <>
      <Button color="error" size="small" startIcon={icon} onClick={handleDialogOpen}>
        {translate(label, { _: label })}
      </Button>
      <Confirm
        isOpen={open}
        loading={isLoading}
        title={confirmTitle}
        content={confirmContent}
        translateOptions={{ id: record.id }}
        onConfirm={handleDelete}
        onClose={handleDialogClose}
      />
    </>
  );
};
